class CartGamification extends HTMLElement {
  constructor() {
    super();
    console.log('[CartGamification] Constructor appelé');
    this.type = this.dataset.type;
    this.steps = Array.from(this.querySelectorAll('.cart-gamification__step'));
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    console.log('[CartGamification] Type:', this.type);
    console.log('[CartGamification] Steps trouvées:', this.steps.length);
    console.log('[CartGamification] Cart element:', this.cart);
  }

  connectedCallback() {
    console.log('[CartGamification] connectedCallback appelé');
    this.steps = Array.from(this.querySelectorAll('.cart-gamification__step'));
    console.log('[CartGamification] Steps après connectedCallback:', this.steps.length);
    console.log('[CartGamification] HTML du composant:', this.innerHTML.substring(0, 500));

    // Petit délai pour s'assurer que le DOM est complètement prêt après rafraîchissement
    setTimeout(() => {
      this.init();
    }, 100);
  }

  init() {
    console.log('[CartGamification] init() appelé');
    console.log('[CartGamification] Dataset complet:', this.dataset);

    this.removeEvents();
    this.bindEvents();
    this.variantsToRemove = this.dataset.variantsToRemove;
    this.variantsToAdd = this.querySelector('[data-variant-to-add]');

    console.log('[CartGamification] variantsToRemove:', this.variantsToRemove);
    console.log('[CartGamification] variantsToAdd:', this.variantsToAdd);

    if (this.variantsToRemove) {
      console.log('[CartGamification] Suppression de variantes...');
      this.removeVariants();
    }

    if (this.variantsToAdd) {
      console.log('[CartGamification] Ajout de variantes...');
      this.addVariants();
    }
  }

  async removeVariants() {
    // Vérifier s'il y a des variantes à supprimer
    if (!this.variantsToRemove) return;

    const variants = this.variantsToRemove.split(',').filter(Boolean);
    if (variants.length === 0) return;

    try {
      // Récupérer le panier actuel
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      // Filtrer les items à supprimer
      const itemsToRemove = cart.items
        .filter((item) => item.properties?._type === this.dataset.gift && variants.includes(item.variant_id.toString()))
        .map((item) => item.key);

      if (itemsToRemove.length === 0) return;

      // Supprimer les items
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates: Object.fromEntries(itemsToRemove.map((key) => [key, 0])),
        }),
      });

      if (!response.ok) throw new Error('Erreur lors de la mise à jour du panier');

      const data = await response.json();

      const cartDrawer = this.closest('cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.toggle('is-empty', data.item_count === 0);
      }

      // Rafraîchir la sidebar (fonctionne pour cart-drawer et page cart)
      if (typeof refreshSidebar === 'function') {
        await refreshSidebar();
      }
    } catch (error) {
      console.error('Erreur lors de la suppression des variantes:', error);
    }
  }

  async addVariants() {
    // Vérifier s'il y a des variantes à ajouter
    if (!this.variantsToAdd) return;

    const variants = this.variantsToAdd.dataset.variantToAdd.split(',').filter(Boolean);
    if (variants.length === 0) return;

    try {
      // Ajouter les variantes
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: variants.map((variant) => ({
            id: variant,
            quantity: 1,
            properties: { _type: this.dataset.gift },
          })),
        }),
      });

      if (!response.ok) throw new Error("Erreur lors de l'ajout des variantes");

      // Rafraîchir la sidebar (fonctionne pour cart-drawer et page cart)
      if (typeof refreshSidebar === 'function') {
        await refreshSidebar();
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.open();
      }
    } catch (error) {
      console.error("Erreur lors de l'ajout des variantes:", error);
    }
  }

  removeEvents() {
    this.querySelectorAll('[data-add-to-cart]').forEach((button) => {
      button.removeEventListener('click', this.handleAddToCart.bind(this));
    });

    this.querySelectorAll('.cart-gamification__variant-option input').forEach((input) => {
      input.removeEventListener('change', this.handleVariantChange.bind(this));
    });

    document.removeEventListener('click', (event) => {
      if (!event.target.closest('cart-gamification details')) {
        this.querySelectorAll('details[open]').forEach((details) => {
          details.removeAttribute('open');
        });
      }
    });
  }

  bindEvents() {
    this.querySelectorAll('[data-add-to-cart]').forEach((button) => {
      button.addEventListener('click', this.handleAddToCart.bind(this));
    });

    this.querySelectorAll('.cart-gamification__variant-option input').forEach((input) => {
      input.addEventListener('change', this.handleVariantChange.bind(this));
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('cart-gamification details')) {
        this.querySelectorAll('details[open]').forEach((details) => {
          details.removeAttribute('open');
        });
      }
    });
  }

  handleVariantChange(event) {
    const input = event.currentTarget;
    const label = input.closest('label');
    const productContainer = input.closest('[data-product-id]');
    const addToCartButton = productContainer.querySelector('[data-add-to-cart]');
    const variantId = input.value;
    const summary = productContainer.querySelector('summary .cart-gamification__variant-price');
    const allLabels = productContainer.querySelectorAll('.cart-gamification__variant-option');

    // Retirer la classe active de tous les labels
    allLabels.forEach((l) => l.classList.remove('option-selected'));

    // Ajouter la classe active au label sélectionné
    label.classList.add('option-selected');

    // Mettre à jour le summary
    if (summary) {
      summary.textContent = label.textContent;
    }

    // Mettre à jour le variant ID
    if (addToCartButton) {
      addToCartButton.dataset.variantId = variantId;
      addToCartButton.removeAttribute('disabled');
    }

    input.closest('details').removeAttribute('open');
  }

  initSwipers() {
    this.querySelectorAll('[data-products-slider]').forEach((slider) => {
      if (slider.swiper) return;

      new Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        grabCursor: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 'auto',
            spaceBetween: 24,
          },
        },
      });
    });
  }

  async handleAddToCart(event) {
    const button = event.currentTarget;
    button.classList.add('loading');
    button.querySelector('.loading__spinner').classList.remove('hidden');
    const productContainer = button.closest('[data-product-id]');
    const variantSelector = productContainer.querySelector('[data-variant-selector]');
    const variantId = button.dataset.variantId || (variantSelector ? variantSelector.value : null);

    if (!variantId) return;

    button.setAttribute('disabled', true);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: { _type: this.dataset.gift },
            },
          ],
        }),
      });

      if (!response.ok) throw new Error("Erreur lors de l'ajout au panier");

      // Rafraîchir la sidebar (fonctionne pour cart-drawer et page cart)
      if (typeof refreshSidebar === 'function') {
        await refreshSidebar();
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.open();
      }
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      button.removeAttribute('disabled');
      button.classList.remove('loading');
      button.querySelector('.loading__spinner').classList.add('hidden');
    }
  }
}

customElements.define('cart-gamification', CartGamification);
